module.exports = __webpack_public_path__ + "static/media/Texas_DSHS_Logo.75073434.svg";